const STATUS_CODES = {
  GATEWAY_TIMEOUT: 504,
}

// commerce sends this to indicate session expiry
const EXPIRED_COOKIE_ERROR = 'ERR_COOKIE_EXPIRED'

// other possible commerce (HCL) session expiry errors
const EXPIRED_ACTIVITY_TOKEN_ERROR_CODE = 'CWXBB1011E'
const EXPIRED_ACTIVITY_TOKEN_ERROR_KEY = 'CWXBB1011E'
const ACTIVITY_TOKEN_ERROR_CODE = 'CWXBB1103E'
const ACTIVITY_TOKEN_ERROR_KEY = '_ERR_ACTIVITY_TOKEN'
const PARTIAL_AUTHENTICATION_ERROR_CODE = 'CWXFR0222E'
const PARTIAL_AUTHENTICATION_ERROR_KEY = 'ERR_PARTIAL_AUTHENTICATION_NOT_ALLOWE' // this is not a typo
const EXPIRED_COOKIE_ERROR_CODE = 'CWXFR0223E'

const SESSION_ERROR = {
  CODES: [
    EXPIRED_COOKIE_ERROR,
    EXPIRED_ACTIVITY_TOKEN_ERROR_CODE,
    ACTIVITY_TOKEN_ERROR_CODE,
    PARTIAL_AUTHENTICATION_ERROR_CODE,
    EXPIRED_COOKIE_ERROR_CODE,
  ],
  KEYS: [
    EXPIRED_COOKIE_ERROR,
    EXPIRED_ACTIVITY_TOKEN_ERROR_KEY,
    ACTIVITY_TOKEN_ERROR_KEY,
    PARTIAL_AUTHENTICATION_ERROR_KEY,
  ],
}

type CommerceSessionError = {
  errorKey?: string
  errorCode?: string
}

export const isGatewayTimeout = (status: unknown | undefined): boolean => status === STATUS_CODES.GATEWAY_TIMEOUT

export const isSessionExpiredError = (error?: unknown): boolean => {
  const sessionError = error as CommerceSessionError
  return (
    SESSION_ERROR.CODES.includes(sessionError?.errorCode ?? '') ||
    SESSION_ERROR.KEYS.includes(sessionError?.errorKey ?? '')
  )
}
